import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box, Button, Typography } from '@material-ui/core';
import {
    loginUser,
    validateLogin,
    showRegisterUser,
} from 'redux/actions/authActions';
import { withStyles } from '@material-ui/styles';
import TextFieldGroup from 'components/common/TextFieldGroup';
import { Theme } from 'utils/Theme';
import clsx from 'clsx';
import SingleSignInContainer from './SingleSignInContainer';
import config from 'coeus.config';

const styles = Theme();

class Login extends Component {
    constructor() {
        super();
        this.state = {
            authMultiFactorMessage: null,
            email: '',
            passcode: '',
            password: '',
            errors: {},
            alert: null,
        };
    }

    changeAuthDetails = (e) => {
        e.preventDefault();
        this.setState({
            authMultiFactorMessage: null,
            email: '',
            password: '',
            passcode: '',
        });
    };

    onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    onValidateLogin = (e) => {
        e.preventDefault();
        this.props.validateLogin({
            email: this.state.email,
            passcode: this.state.passcode,
        });
    };

    onLogin = (e) => {
        e.preventDefault();

        const userData = {
            email: this.state.email,
            password: this.state.password,
        };
        this.props.loginUser(userData, this.props.history);
    };




    onRegister = (e) => {
        e.preventDefault();

        this.props.showRegisterUser();
        this.props.history.push('/register');
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { auth, history } = nextProps;
        let { authMultiFactorMessage, errors } = prevState;

        if (auth.authMultiFactorMessage) {
            authMultiFactorMessage = nextProps.auth.authMultiFactorMessage;
        }

        if (nextProps.auth.errors) {
            if (nextProps.auth.errors.payload) {
                errors = {
                    email: nextProps.auth.errors.payload.message,
                    password: nextProps.auth.errors.payload.message,
                    passcode: nextProps.auth.errors.payload.passcode,
                };
            } else {
                errors = nextProps.auth.errors;
            }
        }

        return { errors, authMultiFactorMessage };
    }

    render() {
        const { classes, auth } = this.props;
        const { errors } = this.state;
        return (
            <form noValidate onSubmit={this.onLogin}>
                <TextFieldGroup
                    label="Email Address"
                    type="email"
                    name="email"
                    error={errors?.email}
                    value={this.state.email}
                    onChange={this.onChange}
                />

                <TextFieldGroup
                    label="Password"
                    type="password"
                    name="password"
                    error={errors?.password}
                    onChange={this.onChange}
                    value={this.state.password}
                />

                <Button
                    className={clsx('c-btn--fullwidth', classes.buttonPrimary)}
                    variant={'contained'}
                    type={'submit'}
                >
                    Login
                </Button>
                <div className="row">
                    {/*<div className={'u-pt-medium col-xs-12 col-sm-6'}>*/}
                    {/*	<Link className='c-btn--fullwidth c-btn c-btn--primary' to={'/register'}> Create Account</Link>*/}
                    {/*</div>*/}
                    <div className={'u-pt-medium col-xs-12 col-sm-12 u-m-auto'}>
                        <Button
                            className={clsx(
                                'c-btn--fullwidth',
                                classes.buttonSecondary
                            )}
                            variant={'contained'}
                            onClick={() =>
                                this.props.history.push('/forgot-password')
                            }
                        >
                            Reset Password
                        </Button>
                        <Box pt={2}>
                            {config.feature.sso_azure.enabled && (
                                <SingleSignInContainer />
                            )}
                        </Box>
                    </div>
                </div>
            </form>
        );
    }
}

Login.propTypes = {
    loginUser: PropTypes.func.isRequired,
    validateLogin: PropTypes.func,
    showRegisterUser: PropTypes.func,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object,
    classes: PropTypes.object,
    theme: PropTypes.object,
    history: PropTypes.object,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    errors: state.auth.errors,
    theme: state.theme,
});

export default connect(mapStateToProps, {
    loginUser,
    validateLogin,
    showRegisterUser,
})(withStyles(styles)(Login));
